import { useNavigate } from '@tanstack/react-router';

import { DemandInformationVessel } from '../../../types/DemandInformationMessage';
import { DropdownMenu } from '../../cdl/DropdownMenu/DropdownMenu';
import { useToasts } from '../../cdl/Toast/useToasts';
import { translate } from '../../common/helpers/translate.helper';
import { useShareDemandWithVessel } from '../hooks/useShareDemandWithVessel';
import { getDefaultDemandRange } from '../utils/getDefaultDemandRange';

interface DemandAdditionalActionsProps {
    vessel: DemandInformationVessel;
}

export const DemandAdditionalActions = ({ vessel }: DemandAdditionalActionsProps) => {
    const navigate = useNavigate();
    const { addToast, addErrorToast } = useToasts();

    const shareWithVesselMutation = useShareDemandWithVessel();

    const navigateToCreateEnquiry = () => {
        navigate({ to: '/orders/new', state: { vesselId: vessel.id, customerId: vessel.customerId } });
    };

    const navigateToVesselSchedule = () => {
        navigate({ to: '/vessel/$id', params: { id: vessel.id }, search: { tab: 'schedule' } });
    };

    const shareWithVessel = (vesselEmailAddress: string) => {
        const [fromDate, toDate] = getDefaultDemandRange();

        const requestMessage = {
            receiverEmailAddresses: [vesselEmailAddress],
            copyToSelf: true,
            fromDate,
            toDate,
        };

        shareWithVesselMutation.mutate(
            {
                vesselId: vessel.id,
                requestMessage,
            },
            {
                onSuccess: () => {
                    addToast(translate('demand.shareDemandWithVesselSuccess'));
                },
                onError: () => {
                    addErrorToast(translate('demand.shareDemandWithVesselError'));
                },
            }
        );
    };

    const options = [
        {
            label: translate('demand.createEnquiry'),
            onSelect: navigateToCreateEnquiry,
        },
    ];

    if (vessel.stops.length) {
        options.push({
            label: translate('demand.viewSchedule'),
            onSelect: () => navigateToVesselSchedule(),
        });
    }

    if (vessel.email && vessel.latestStocks.length && vessel.stops.length) {
        options.push({
            label: translate('demand.shareDemandWithVessel'),
            onSelect: () => shareWithVessel(vessel.email!),
        });
    }

    return <DropdownMenu align="end" options={options} />;
};
